export default __webpack_public_path__ + "static/media/about-us.e86ee71d.png";